import { Chip, Stack, Typography } from '@mui/material';
import {
  formatOfferedSlotChip,
  MAX_OFFERED_SLOTS,
} from '../../utils/form/offeredSlots';

type ChipsProps = {
  starts: string[];
  appointmentLengthInMinutes: string | undefined;
  timezone: string;
  onDelete?: (start: string) => void;
};

type Props = ChipsProps & {
  showCounter?: boolean;
  helperText?: string;
};

/**
 * The chips themselves, unwrapped. The picker's tray and the form row lay them
 * out differently, so each supplies its own container.
 */
export function OfferedSlotChips({
  starts,
  appointmentLengthInMinutes,
  timezone,
  onDelete,
}: ChipsProps) {
  return (
    <>
      {starts.map(start => (
        <Chip
          key={start}
          size="small"
          label={formatOfferedSlotChip(
            start,
            appointmentLengthInMinutes,
            timezone,
          )}
          onDelete={onDelete ? () => onDelete(start) : undefined}
        />
      ))}
    </>
  );
}

export default function SelectedSlotChips({
  starts,
  appointmentLengthInMinutes,
  timezone,
  onDelete,
  showCounter = true,
  helperText,
}: Props) {
  return (
    <Stack spacing={1} mt={1} mb={1.5} mx={1.5}>
      {(showCounter || !!helperText) && (
        <Typography variant="body2" color="text.secondary">
          {showCounter && `${starts.length} of ${MAX_OFFERED_SLOTS} selected`}
          {showCounter && helperText && ' · '}
          {helperText}
        </Typography>
      )}
      {!!starts.length && (
        <Stack direction="row" flexWrap="wrap" gap={0.75}>
          <OfferedSlotChips
            starts={starts}
            appointmentLengthInMinutes={appointmentLengthInMinutes}
            timezone={timezone}
            onDelete={onDelete}
          />
        </Stack>
      )}
    </Stack>
  );
}
